import {Warehouse} from 'lucide-react';
import type {RouteObject} from 'react-router-dom';

import type {MenuItemElement} from '@/components/menu/Menu';
import i18n from '@/i18n';
import {protectedLoader} from '@/utils/protectedLoader';

export const routes = [
  {
    path: 'inventory',
    children: [
      {
        path: '',
        loader: protectedLoader('INVENTORY', 'VIEW_WAREHOUSES'),
        async lazy() {
          const {WarehouseListPage} = await import('./pages/WarehouseListPage');
          return {element: <WarehouseListPage />};
        },
        children: [
          {
            path: 'add',
            loader: protectedLoader('INVENTORY', 'CREATE_WAREHOUSE'),
            async lazy() {
              const {AddWarehousePage} = await import(
                './pages/AddWarehousePage'
              );
              return {
                element: <AddWarehousePage />,
              };
            },
          },
        ],
      },
      {
        path: ':id',
        loader: protectedLoader('INVENTORY', 'VIEW_WAREHOUSE'),
        async lazy() {
          const {WarehousePage} = await import('./pages/WarehousePage');
          return {element: <WarehousePage />};
        },
        children: [
          {
            path: 'add',
            loader: protectedLoader('INVENTORY', 'CREATE_WAREHOUSE_ITEM'),
            async lazy() {
              const {AddWarehouseItemPage} = await import(
                './pages/AddWarehouseItemPage'
              );
              return {
                element: <AddWarehouseItemPage />,
              };
            },
          },
          {
            path: ':itemId',
            loader: protectedLoader('INVENTORY', 'VIEW_WAREHOUSE'),
            async lazy() {
              const {EditWarehouseItemPage} = await import(
                './pages/EditWarehouseItemPage'
              );
              return {
                element: <EditWarehouseItemPage />,
              };
            },
          },
          {
            path: ':itemId/qty',
            loader: protectedLoader('INVENTORY', 'VIEW_WAREHOUSE'),
            async lazy() {
              const {UpdateWarehouseItemStockPage} = await import(
                './pages/UpdateWarehouseItemStockPage'
              );
              return {
                element: <UpdateWarehouseItemStockPage />,
              };
            },
          },
          {
            path: ':itemId/transfer',
            loader: protectedLoader('INVENTORY', 'UPDATE_WAREHOUSE_ITEM'),
            async lazy() {
              const {TransferWarehouseItemPage} = await import(
                './pages/TransferWarehouseItemPage'
              );
              return {
                element: <TransferWarehouseItemPage />,
              };
            },
          },
        ],
      },
    ],
  },
] as RouteObject[];

export const menuItems = [
  {
    path: '/inventory',
    text: i18n.t('Inventory'),
    icon: <Warehouse />,
    permission: 'VIEW_WAREHOUSES',
    entitlement: 'INVENTORY',
  },
] as MenuItemElement[];
